import React from 'react';
import Loader from '../../common/Loader';
import styles from './styles.styl';

function LoaderInPopup() {
  return (
    <div className={styles.root}>
      <Loader />
    </div>
  );
}

export default LoaderInPopup;



// WEBPACK FOOTER //
// ./src/components/Ui/LoaderInPopup/index.jsx